import apiRequestType from "../apiRequestType";
import { apiTypes } from "../../utils/apiTypes";
import { apiConstants } from "../../utils/apiConstants";

const putMyProfile = (data, payloadData) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.PROFILE.PUT_MY_PROFILE(data.isPswdChanged, data.tenantName, data.isCustomLogin),
    payloadData
  );
};

export default putMyProfile;
